import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { MasterService } from '../../../../services/master.service';
import { BenefitsService } from '../../../../services/benefits.service';
import { Router } from '@angular/router';
import { LoaderProvider } from '../../../../utils/providers/loader-provider';
import * as moment from 'moment';
import { Moment } from 'moment';
import { DeleteStrPipe } from '../../../pipes/delete-str.pipe';

@Component({
  selector: 'app-edit-benefit-dialog',
  templateUrl: './edit-benefit-dialog.component.html',
  styleUrls: ['./edit-benefit-dialog.component.scss']
})
export class EditBenefitDialogComponent implements OnInit {
  @Input() benefitData;
  benefitForm: FormGroup;
  minDate: Moment;
  currentDate: any;

  // List
  ubigeoList: any[] = [];
  institutionsList: any[] = [];
  // File variables
  fileImg64: string | ArrayBuffer;
  fileImg64Detail: string | ArrayBuffer;
  fileImg64DetailMobile: string | ArrayBuffer;
  wrongSize: any[] = [];

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private serviceMaster: MasterService,
    private serviceBenefits: BenefitsService,
    private loader: LoaderProvider,
    private router: Router) {
  }

  ngOnInit(): void {
    const date = new Date();
    const day = (date.getDate() + 1).toString();
    const formatDay = day.length === 1 ? `0${day}` : day;
    const month = (date.getMonth() + 1).toString();
    const year = date.getFullYear().toString();
    this.currentDate = `${year}-${month}-${formatDay}`;
    this.benefitForm = this.fb.group({
      ubigeoId: [(this.benefitData ? this.benefitData.ubigeo : null), Validators.required], // Listo
      startDate: [(this.benefitData.dateInitial ? moment(this.benefitData.dateInitial).format() : null), Validators.required], // Listo
      endDate: [(this.benefitData.dateFinish ? moment(this.benefitData.dateFinish).format() : null), Validators.required], // Listo
      img: ['', Validators.required], // Listo
      img64: [(this.benefitData ? this.benefitData.imagen : null), Validators.required], // Listo
      imgDetail: ['', Validators.required], // Listo
      img64Detail: [(this.benefitData ? this.benefitData.imagenDetail : null), Validators.required], // Listo
      imgDetailMobile: ['', Validators.required], // Listo
      img64DetailMobile: [(this.benefitData ? this.benefitData.imagenDetailMobile : null), Validators.required], // Listo
      discountMount: [(this.benefitData ? this.benefitData.discountMont : null), Validators.required], // Listo
      discountText: [(this.benefitData ? this.benefitData.discountText : null), Validators.required], // Listo
      detailHtml: [(this.benefitData ? this.benefitData.detailHTML : null)], // Listo
      urlCoupon: [(this.benefitData ? this.benefitData.urlCoupon : null)],
      descriptionBoxHtml: [(this.benefitData ? this.benefitData.descriptionBoxHtml : '')], // No va
      buttonTextBoxHtml: [(this.benefitData ? this.benefitData.buttonTextBoxHTML : '')], // No va
      urlBox: [(this.benefitData ? this.benefitData.urlBox : '')], // No va
      detailHtml2: [(this.benefitData ? this.benefitData.detailHTML2 : null)], // Listo
      detailHtml3: [(this.benefitData && this.benefitData.detailHTML3 ? this.lineBreakBulletPoint(this.benefitData.detailHTML3) : '• Válido presentando ...'), Validators.required], // Listo
      benefitsInstitutionId: [(this.benefitData ? this.benefitData.benefitInstitutionId : null), Validators.required], // Listo
      imagenDetailPrint64: [this.benefitData.imagenDetailPrint64]
    });

    this.benefitData ? this.fileImg64 = this.benefitData.imagen : this.fileImg64 = null;
    this.benefitData ? this.fileImg64Detail = this.benefitData.imagenDetail : this.fileImg64Detail = null;
    this.benefitData ? this.fileImg64DetailMobile = this.benefitData.imagenDetailMobile : this.fileImg64DetailMobile = null;
    this.gettingUbigeos();
    this.gettingInstitutions();

    if (this.benefitData.id) { // En edición las imágenes no son necesariamente modificadas
      this.benefitForm.get('img').setValidators(null);
      this.benefitForm.get('img64').setValidators(null);
      this.benefitData.imgUpload = false; // viene por defecto pero es bueno tenerlo en cuenta
      this.benefitForm.get('imgDetail').setValidators(null);
      this.benefitForm.get('img64Detail').setValidators(null);
      this.benefitData.imgDetailUpload = false; // viene por defecto pero es bueno tenerlo en cuenta
      this.benefitForm.get('imgDetailMobile').setValidators(null);
      this.benefitForm.get('img64DetailMobile').setValidators(null);
      this.benefitData.imgDetailMobileUpload = false; // viene por defecto pero es bueno tenerlo en cuenta
    }
  }

  getBase64(event, place: string): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        switch (place) {
          case 'carrousel':
            if (image.width === 212 && image.height === 160) {
              this.wrongSize['c'] = null;
                this.fileImg64 = image.src;
              this.benefitForm.get('img').setValue((event.target.files[0]).name);
              this.benefitForm.get('img64').setValue(this.fileImg64.split(',')[1]);
              this.benefitData.imgUpload = this.benefitData.id ? true : null; // Si es editar setea true | si es lectura es indiferente (no se usa)
            } else {
              this.wrongSize['c'] = 'Resolución de imagen carrusel no permitida (requerida: 212px x 160px)';
              return false;
            }
            break;
          case 'slider':
            if (image.width === 330 && image.height === 637) {
              this.wrongSize['s'] = null;
              this.fileImg64Detail = image.src;
              this.benefitForm.get('imgDetail').setValue((event.target.files[0]).name);
              this.benefitForm.get('img64Detail').setValue(this.fileImg64Detail.split(',')[1]);
              this.benefitData.imgDetailUpload = this.benefitData.id ? true : null; // Si es editar setea true | si es lectura es indiferente (no se usa)
            } else {
              this.wrongSize['s'] = 'Resolución de imagen modal no permitida (requerida: 330px x 637px)';
              return false;
            }
            break;
          case 'sliderMobile':
            if (image.width === 329 && image.height === 85 /* Or 85 */) {
              this.wrongSize['sM'] = null;
              this.fileImg64DetailMobile = image.src;
              this.benefitForm.get('imgDetailMobile').setValue((event.target.files[0]).name);
              this.benefitForm.get('img64DetailMobile').setValue(this.fileImg64DetailMobile.split(',')[1]);
              this.benefitData.imgDetailMobileUpload = this.benefitData.id ? true : null; // Si es editar setea true | si es lectura es indiferente (no se usa)
            } else {
              this.wrongSize['sM'] = 'Resolución de imagen modal mobile no permitida (requerida: 329px x 85px)';
              return false;
            }
            break;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  deleteTag(value): string {
    const openTag = '<p>';
    const closeTag = '</p>';
    const strangeCharacter = '&lt;/p&gt;';
    return value.replace(openTag, '').replace(closeTag, '').replace(strangeCharacter, '');
  }

  isValid(): void {
    // const exampleStr = this.deleteTag(this.benefitForm.value.detailHtml3);
    this.benefitForm.value.detailHtml3 = this.benefitForm.value.detailHtml3.replaceAll('<br>', '');
    const dataToSend = { ...this.benefitForm.value };
    if (this.benefitData.id) {
      dataToSend.id = this.benefitData.id;
      dataToSend.categoryId = this.benefitData.categoryId;
      dataToSend.imgUpload = this.benefitData.imgUpload;
      dataToSend.imgDetailUpload = this.benefitData.imgDetailUpload;
      dataToSend.imgDetailMobileUpload = this.benefitData.imgDetailMobileUpload;
    }
    if (this.benefitData['categoryId']) {
      dataToSend.categoryId = this.benefitData['categoryId'];
    }
    this.activeModal.close(dataToSend);
    // sessionStorage.setItem('benefitToPrint', JSON.stringify(dataToSend));
    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree([`admin/print-benefit`])
    // );
    // window.open(url, '_blank');
  }

  // Variables
  gettingUbigeos(): void {
    const sub = this.serviceMaster.getAllUbigeos().pipe(
      finalize(() => sub.unsubscribe())
    ).subscribe((res: any) => {
      res.unshift({ id: 0, name: 'TODOS' });
      this.ubigeoList = res;
    });
  }

  gettingInstitutions(): void {
    const sub = this.serviceBenefits.gettingBenefitsInstitutions().pipe(
      finalize(() => sub.unsubscribe())
    ).subscribe((res: any) => this.institutionsList = res.filter(x => x.status == 'Activo'));
  }

  detectDate($event: Event) {
  }

  convertDate(date?: any): any {
    return date ? this.takeOutHMS(new Date(date)) : this.takeOutHMS(new Date());
  }

  takeOutHMS(fec: Date) {
    fec.setHours(0);
    fec.setMinutes(0);
    fec.setSeconds(0);
    fec.setMilliseconds(0)
    return fec;
  }

  lineBreakBulletPoint(detailHTML3: any) {
    detailHTML3 = detailHTML3.replaceAll("•", "<br>•");
    return detailHTML3.substring(7, detailHTML3.length);
  }
}
